/*
JS Components
*/

import "./quote-form/index--split";
import "./choose-form/index--split";
import "./product-card/index--split";
import "./cover-selector/index--split";
import "./required-field/index--split";
import "./date-field/index--split";
import "./localize-date/index--split";
import "./site-header";
import "./modal/index";
import "./search";
import "./epi-blocks";
import "./alerts";
import "./wysiwyg/index";
import "./scrollbar-width/index";
import "./ajax-submit/index--split";
import "./sync-same-name/index--split";



// WEBPACK FOOTER //
// ./project/client/src/core/components/index.js